import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=4b35384c&"
import script from "./BlockDetails.vue?vue&type=script&lang=js&"
export * from "./BlockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports